<p-button
  [label]="options?.title || ''"
  icon="pi pi-plus"
  class="p-button-text p-button-text_blue"
  (click)="onClickButton()"
/>
